var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 43,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 83.363,
  height: 4,
  x: 36.637,
  y: 6.829,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-text)",
  d: "M28.342 3.357v1.23h-4.156v-1.23zM25.3 1.54h1.517v7.39q0 .457.192.676.191.213.636.212.122 0 .314-.027t.328-.055l.267 1.21q-.246.082-.527.117-.273.04-.533.04-1.046 0-1.62-.533-.574-.54-.574-1.517V1.539ZM16.372 11l2.994-4.512-.007 1.176-2.837-4.307h1.71l.86 1.388q.357.581.623 1.108.266.525.554 1.018h-.69q.285-.493.532-1.018.253-.526.616-1.108l.881-1.388h1.675l-2.857 4.348V6.563L23.406 11h-1.702L20.68 9.38a16 16 0 0 1-.622-1.08 17 17 0 0 0-.54-.998h.697q-.28.478-.526.998-.24.513-.595 1.08L18.06 11h-1.689Zm-4.012.157q-1.129 0-1.949-.485a3.25 3.25 0 0 1-1.265-1.367q-.437-.882-.437-2.072 0-1.175.43-2.07a3.34 3.34 0 0 1 1.231-1.395q.793-.506 1.86-.506.655 0 1.264.218.615.213 1.1.67.486.459.766 1.19.288.73.288 1.764v.533H9.543V6.509h5.325l-.71.369q0-.697-.22-1.23a1.8 1.8 0 0 0-.642-.835q-.424-.3-1.06-.3t-1.087.307-.69.807a2.56 2.56 0 0 0-.232 1.094v.765q0 .78.266 1.327.273.54.759.82.485.273 1.121.273.417 0 .759-.116.348-.123.595-.362.246-.246.375-.602l1.422.335a2.5 2.5 0 0 1-.615 1.046q-.43.45-1.08.704a4.1 4.1 0 0 1-1.47.246ZM.615 2.168V.814h7.916v1.354H5.366V11H3.794V2.168z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 4,
  y: 22.829,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 4,
  y: 38.829,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})));
export default SvgText;